import CloseIcon from '@mui/icons-material/Close';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';

function FiltersModel({
  title = '',
  titleVariant = 'h5',
  children,
  applyButtonLabel = '',
  resetButtonLabel = '',
  applyButtonOnClick,
  resetButtonOnClick,
  buttonLoading = false,
  open,
  onClose,
  containerWidth = 'lg',
  gridSpacing = 2,
  disableButton,
  desktopModalPadding = '2rem',
  desktopModalWidth = '40%',
  mobileModalPadding = '2rem 1rem',
  mobileModalWidth = '90%',
  desktopModalHeight,
}) {
  const isDesktop = useMediaQuery('(min-width:600px)');

  const mobileModalStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    border: '2px solid grey',
    borderRadius: '10px',
    padding: mobileModalPadding,
    width: mobileModalWidth,
    overflow: 'auto',
  };
  const desktopModalStyles = {
    position: 'relative',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    border: '2px solid grey',
    borderRadius: '10px',
    padding: desktopModalPadding,
    width: desktopModalWidth,
    height: desktopModalHeight,
    overflow: 'auto',
  };

  return (
    <Modal open={open} onClose={() => onClose(false)}>
      <Box sx={isDesktop ? desktopModalStyles : mobileModalStyles}>
        <CloseIcon
          onClick={() => onClose(false)}
          className="absolute cursor-pointer top-4 right-4"
        />
        <Container maxWidth={containerWidth}>
          <Grid container spacing={gridSpacing}>
            {title && (
              <Grid item xs={12}>
                <Typography
                  id="modal-modal-title"
                  variant={titleVariant}
                  textAlign="center"
                >
                  {title}
                </Typography>
              </Grid>
            )}
            <Box sx={{
              maxHeight: 'calc(100vh - 200px)', overflowY: 'auto', pt: 2,
            }}
            >
              <Grid item xs={12}>
                {children}
              </Grid>
            </Box>
            {applyButtonLabel.length > 0 && (
              <Grid item xs={12}>
                <Stack spacing={2} direction="row" justifyContent="end" alignItems="center">
                  <Button
                    onClick={resetButtonOnClick}
                    variant="text"
                    className="bold text-primary-600"
                  >
                    {resetButtonLabel}
                  </Button>
                  <LoadingButton
                    onClick={applyButtonOnClick}
                    variant="contained"
                    // color="success"
                    className="bold"
                    disabled={disableButton || buttonLoading}
                    loading={buttonLoading}
                  >
                    {applyButtonLabel}
                  </LoadingButton>
                </Stack>
              </Grid>
            )}
          </Grid>
        </Container>
      </Box>
    </Modal>
  );
}

export default FiltersModel;
